<div #container class="wrapper">
  @for (item of visibleItems; track item.label) {
    @if (itemTemplate) {
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"/>
    }
    @if (separatorTemplate && !isLastItem(item)) {
      <ng-container *ngTemplateOutlet="separatorTemplate; context: { $implicit: item }"/>
    }
  }

  @if (hiddenItems.length) {
    @if (moreButtonTemplate) {
      <ng-container *ngTemplateOutlet="moreButtonTemplate; context: { count: hiddenItems.length }"/>
    }
  }
</div>

<!-- Template par défaut pour item -->
<ng-template #defaultItem let-item>
  <div class="item">
    {{ item.label }}
  </div>
</ng-template>

<!-- Template par défaut pour le bouton -->
<ng-template #defaultMoreButton let-count="count">
  <button class="more-button">+{{ count }}</button>
</ng-template>

<!-- Si aucune projection, on utilise les templates par défaut -->
@if (!itemTemplate) {
  <ng-template #itemTemplateRef>
    <ng-container *ngTemplateOutlet="defaultItem"/>
  </ng-template>
}
@if (!moreButtonTemplate) {
  <ng-template #moreButtonTemplateRef>
    <ng-container *ngTemplateOutlet="defaultMoreButton"/>
  </ng-template>
}
